<div mdbModal #seleccionarProducto="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample"
  tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="mode === 'SEARCH'">
          Seleccionar producto
        </h4>
        <h4 class="modal-title w-100 text-left" id="myModalLabel" *ngIf="mode === 'VIEW_SELECTED'">
          Seleccionados
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CerrarModal()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form [formGroup]='formData' (ngSubmit)="buscar(true)">
        <div class="modal-body" *ngIf="mode === 'SEARCH'">
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="sku" class="form-control" placeholder="SKU" required #sku
                  formControlName="sku" />
                <label for="sku">SKU</label>
              </div>
            </div>
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="descripcion" class="form-control" placeholder="Descripción" required
                  #descripcion formControlName="descripcion" />
                <label for="descripcion">Descripción</label>
              </div>
            </div>
            <div class="col dato" style="max-width: 300px;">
              <div class="md-form">
                <mdb-select label="Rubro" placeholder="Rubro" [options]="optionsRubro" [filterEnabled]="true"
                  formControlName="rubro" [multiple]="true" (selected)='onRubroSelect($event)'></mdb-select>
              </div>
            </div>
            <div class="col dato" style="max-width: 300px;">
              <div class="md-form">
                <mdb-select label="Familia" placeholder="Familia" [options]="optionsFamilia" [filterEnabled]="true"
                  formControlName="familia" [multiple]="true"></mdb-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col dato" style="display: flex; align-items: center; min-width: 240px;"
              *ngIf="showFiltroActivoInactivo">
              <!-- Switch -->
              <div class="switch danger-switch">
                <label>
                  Inactivo
                  <input type="checkbox" formControlName="activo" />
                  <span class="lever"></span>
                  Activo
                </label>
              </div>
            </div>
            <div class="col dato" style="display: flex; justify-content: flex-start; align-items: center;">
              <!-- Material inline 1 -->
              <div class="form-check form-check-inline" style="margin-right: 20px;">
                <input type="radio" class="form-check-input" [id]="idAfecto" mdbInput formControlName="afectoOrExento"
                  [value]="TIPO_AFECTO" />
                <label class="form-check-label" [for]="idAfecto">Afecto</label>
              </div>

              <!-- Material inline 2 -->
              <div class="form-check form-check-inline">
                <input type="radio" class="form-check-input" [id]="idExcento" mdbInput formControlName="afectoOrExento"
                  [value]="TIPO_EXCENTO" />
                <label class="form-check-label" [for]="idExcento">Exento</label>
              </div>
            </div>

            <ng-container *ngIf="showUnidadDeNegocioIfAllowed && permiteUnidadNegocio">
              <div class="col dato" style="max-width: 300px;">
                <div class="md-form">
                  <mdb-select label="Unidad de Negocio" [options]="optionsUnidadesDeNegocio"
                    placeholder="Unidad de negocio" [filterEnabled]="true" formControlName="unidad_negocio_codigo">
                  </mdb-select>
                </div>
              </div>
            </ng-container>
          </div>

          <div class="row justify-content-end" style="border-top: 1px solid #dee2e6;">
            <ng-container *ngIf="showSelectAll && dataAll?.length > 0 && checkedRecords > 0">
              <button class="btn btn-sm" size="sm" mdbBtn type="button" color="info" mdbWavesEffect
                (click)="selectChecked()">
                <mdb-icon fas icon="check"></mdb-icon>
                Seleccionar los {{checkedRecords}}
              </button>
            </ng-container>
            <button class="btn btn-sm" size="sm" mdbBtn type="submit" color="info" mdbWavesEffect>
              <mdb-icon fas icon="search"></mdb-icon>
              Buscar
            </button>
          </div>

          <!-- <div class="row" *ngIf="busquedaIniciada && data.length === 0">
            <div class="col">
              <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
                No existen registros para el filtro seleccionado</a>
            </div>
          </div> -->

          <table class="table table-striped table-hover table-sm align-middle mt-1" *ngIf="busquedaIniciada">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">
                  <ng-container *ngIf="showSelectAll">
                    <mdb-checkbox (change)='checkAllChange($event)' [ngModelOptions]="
                    {standalone: true}" [(ngModel)]="checkAll">
                      <span>
                        SKU
                      </span>
                    </mdb-checkbox>
                  </ng-container>
                  <ng-container *ngIf="!showSelectAll">
                    SKU
                  </ng-container>
                </th>
                <th scope="col">Descripción</th>
                <th *ngIf="showInforAdicionar" scope="col">Cod. Form Prin.</th>
                <th *ngIf="showInforAdicionar" scope="col">Form. Descripción</th>
                <th *ngIf="showInforAdicionar" scope="col">Saldo</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loading">
                <td colspan="100%" style="text-align: center">
                  <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </td>
              </tr>
              <tr *ngIf="!loading && data?.length === 0">
                <td colspan="100%" style="text-align: center">
                  No se encontró información
                </td>
              </tr>
              <tr *ngFor="let producto of data; let i = index;">
                <td>
                  <ng-container *ngIf="showSelectAll">
                    <mdb-checkbox [checked]="producto.additionalInfo?.checked"
                      (change)='toogleCheckProducto(producto, $event)'>
                      <span>
                        {{ producto.sku }}
                      </span>
                    </mdb-checkbox>
                  </ng-container>
                  <ng-container *ngIf="!showSelectAll">
                    {{ producto.sku }}
                  </ng-container>
                </td>
                <td>{{ producto.descripcion }}</td>
                <td *ngIf="showInforAdicionar">{{ producto.formato_codigo }}</td>
                <td *ngIf="showInforAdicionar">{{ producto.formato_nombre }}</td>
                <td *ngIf="showInforAdicionar">{{ producto.cantidad }}</td>
                <td>
                  <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn btn-sm" size="sm"
                    (click)="selectData(producto)">
                    Seleccionar
                  </button>
                </td>
              </tr>
            </tbody>
            <ng-container *ngIf="data?.length > 0">
              <app-pagination *ngIf="!paginateLocally" [context]="paginationContext"
                (onPageChange)="onPageChange($event)"></app-pagination>
              <app-pagination *ngIf="paginateLocally" [context]="paginationContext"
                (onPageChange)="onPageChangeLocal($event)"></app-pagination>
            </ng-container>
          </table>
        </div>
        <div class="modal-body" *ngIf="mode === 'VIEW_SELECTED'">
          <h5 *ngIf="data?.length === 1">
            ({{dataAll?.length | json}}) Seleccionado
          </h5>
          <h5 *ngIf="data?.length > 1">
            ({{dataAll?.length | json}}) Seleccionados
          </h5>
          <table class="table table-striped table-hover table-sm align-middle mt-1">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">SKU</th>
                <th scope="col">Descripción</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let producto of data">
                <td>
                  <!-- <mdb-checkbox [checked]="producto.additionalInfo?.checked"
                    (change)='uncheckProductoSeleccionado(producto)'>
                    <span>
                      {{ producto.sku }}
                    </span>
                  </mdb-checkbox> -->
                  {{ producto.sku }}
                </td>
                <td>{{ producto.descripcion }}</td>
                <td>
                  <button mdbBtn type="button" size="sm" color="danger" mdbWavesEffect class="btn-actions-sm"
                    (click)="uncheckProductoSeleccionado(producto)">
                    <mdb-icon fas icon="trash"></mdb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
            <ng-container *ngIf="data?.length > 0">
              <app-pagination *ngIf="!paginateLocally" [context]="paginationContext"
                (onPageChange)="onPageChange($event)"></app-pagination>
              <app-pagination *ngIf="paginateLocally" [context]="paginationContext"
                (onPageChange)="onPageChangeLocal($event)"></app-pagination>
            </ng-container>
          </table>
        </div>
      </form>
    </div>
  </div>
</div>